// Entry point for the build script in your package.json
import $ from "jquery";
window.$ = $;
window.jQuery = $;

import Rails from '@rails/ujs';
Rails.start();

import "bootstrap";
import "popper.js"; // Bootstrap 4 necesita esta versión

// ✅ Plugins dependientes de jQuery
import "jquery-mousewheel";
import "jquery-match-height";
import "jscrollpane";
import "@nathanvda/cocoon"
import "blueimp-tmpl/js/tmpl.min.js";                         // plantillas
import "blueimp-load-image/js/load-image.all.min.js";         // preview/resizing
import 'blueimp-load-image/js/load-image-orientation.js';
import 'blueimp-load-image/js/load-image-exif.js';
import "blueimp-canvas-to-blob/js/canvas-to-blob.min.js";     // blob conversion
import "blueimp-file-upload/js/jquery.fileupload.js";         // core plugin
import "blueimp-file-upload/js/jquery.fileupload-process.js"; // procesamiento de archivos
import "blueimp-file-upload/js/jquery.fileupload-image.js";   // soporte de imagen
import "blueimp-file-upload/js/jquery.fileupload-validate.js";// validación
import "blueimp-file-upload/js/jquery.fileupload-ui.js";      // interfaz de usuario
import "blueimp-file-upload/js/vendor/jquery.ui.widget.js";   // widget factory
import "blueimp-file-upload/js/jquery.iframe-transport.js";   // transporte iframe (si se usa)
import tailSelect from "tail.select.js";
window.tailSelect = tailSelect;

// Plugins
import "../plugins/bootstrap-datetimepicker";
import { Transfer } from "../plugins/jquery.transfer";
window.Transfer = Transfer;

// ✅ Core utilidades JS
import moment from "moment";
import Swal from "sweetalert2";
import bootbox from "bootbox";
import "inputmask";
import "daterangepicker";
import "jquery-validation";

// ✅ Select2 (debe ir después de exponer window.$)
import select2 from "select2/dist/js/select2.full.min.js";
window.select2 = select2;
select2($);
$.fn.select2.defaults.set("theme", "bootstrap4");

window.moment = moment;
window.Swal = Swal;
window.bootbox = bootbox;

// ✅ Tus módulos personalizados
import "../modules/app";
import Commons from "../modules/commons";
window.Commons = Commons;
import BulkAction from "../modules/bulk_action";
window.BulkAction = BulkAction;
import Quotes from "../modules/quotes"
window.Quotes = Quotes;

import { initBarGlobal } from "../modules/dashboard";
document.addEventListener("DOMContentLoaded", () => {
  const chartData = window.BAR_CHART_DATA;

  if (chartData) {
    initBarGlobal(chartData);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  var app = new Commons();
  app.loadComponents();
});
